<template>
  <div
    class="badge p-3 fs-5 fw-normal w-100 text-start text-wrap"
    :class="`bg-opacity-${opacity} text-${textColor} bg-${bgColor}`"
  >
    <slot v-if="!message" />
    <span v-else>{{ message }}</span>
  </div>
</template>

<script setup lang="ts">
import { PropType } from 'vue'
import { BootstrapColorEnum } from '@/shared'

defineProps({
  message: {
    type: String,
    default: undefined,
  },
  bgColor: {
    type: String as PropType<BootstrapColorEnum>,
    required: false,
    default: BootstrapColorEnum.Primary,
  },
  textColor: {
    type: String as PropType<BootstrapColorEnum>,
    required: false,
    default: BootstrapColorEnum.Primary,
  },
  opacity: {
    type: Number,
    required: false,
    default: 10,
  },
})
</script>
